<template>
  <div>
    <c-row>
      <c-col lg="6">
        <c-table-wrapper :items="getShuffledUsersData()">
          <template #header>
            <c-icon name="cil-grid" />
            Simple Table
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/nav"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </template>
        </c-table-wrapper>
      </c-col>

      <c-col lg="6">
        <c-table-wrapper :items="getShuffledUsersData()" striped caption="Striped Table" />
      </c-col>
    </c-row>

    <c-row>
      <c-col lg="6">
        <c-table-wrapper :items="getShuffledUsersData()" small caption="Condensed Table" />
      </c-col>

      <c-col lg="6">
        <c-table-wrapper :items="getShuffledUsersData()" fixed bordered caption="Bordered Table" />
      </c-col>
    </c-row>

    <c-row>
      <c-col sm="12">
        <c-table-wrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Combined All Table"
        />
      </c-col>
    </c-row>

    <c-row>
      <c-col sm="12">
        <c-table-wrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          dark
          caption="Combined All dark Table"
        />
      </c-col>
    </c-row>
  </div>
</template>

<script>
import CTableWrapper from './Table.vue';
import usersData from '../users/UsersData';

export default {
  name: 'Tables',
  components: { CTableWrapper },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    getShuffledUsersData() {
      return this.shuffleArray(usersData.slice(0));
    },
  },
};
</script>
